import axiosInstance from "../axiosInstance";

export const GETDetalleOrdenREU = async (idomam) => {
  try {
    const response = await axiosInstance.get(
      `${process.env.REACT_APP_WMS_BASE_URL}/ordenes/orden-omareu-ope/${idomam}`,
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );

    return {
      status: response.status,
      data: response.data,
    };
  } catch (error) {
    // Errores de red u otros
    return {
      status: error.response?.status,
      data: error.response?.data,
      message:
        error.response?.data?.message || "Error al realizar la solicitud",
    };
  }
};

export default GETDetalleOrdenREU;
